var _rect, _circle, _circle2, _path, _path2, _path3, _line, _line2, _path4, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChinesefood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    rx: 30,
    fill: "#FF7D7D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 177.5,
    cy: 98.9286,
    r: 37.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6429,
    cy: 98.9286,
    r: 37.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.039 151.128C179.438 150.885 181.718 150.954 183.702 151.64C185.762 152.352 187.41 153.697 188.493 155.771C189.54 157.775 190 160.339 190 163.445C190 176.061 182.429 187.249 170.667 195.193C158.894 203.146 142.742 208 125 208C107.258 208 91.1064 203.146 79.333 195.193C67.5713 187.249 60 176.061 60 163.445C60 160.339 60.4605 157.775 61.5068 155.771C62.5904 153.697 64.2377 152.352 66.2979 151.64C68.2822 150.954 70.5621 150.885 72.9609 151.128C75.3753 151.373 78.0682 151.952 80.9512 152.695C92.6126 155.7 107.939 161.445 125 161.445C142.061 161.445 157.387 155.7 169.049 152.695C171.932 151.952 174.625 151.373 177.039 151.128Z",
    fill: "white",
    stroke: "#DE6D6D",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1053 87.9541C57.3828 85.5035 60.6894 83.9944 64.0601 84.0056C66.7225 83.9657 69.3897 84.7854 71.5671 86.3072C72.9064 87.2248 74.025 88.4203 74.9935 89.7103C75.193 89.5325 75.3502 89.317 75.5138 89.1084C77.2358 86.9651 79.5915 85.288 82.2609 84.5383C84.4221 83.8797 86.7651 83.8265 88.9565 84.3731C92.4535 85.2432 95.5289 87.7322 96.9922 91.0164C97.5758 92.3723 97.9508 93.8289 97.9917 95.3073C98.0932 98.0301 97.2552 100.742 95.8291 103.053C94.7387 104.771 93.4114 106.326 92.0178 107.807C86.9019 113.253 81.1261 118.027 75.3517 122.76C75.2452 122.853 75.1268 122.931 75.0035 123C69.1113 118.204 63.2616 113.317 58.0327 107.8C56.7773 106.444 55.5558 105.049 54.5104 103.525C52.823 101.068 51.8452 98.0784 52.0201 95.0903C52.1815 92.4542 53.286 89.8825 55.1053 87.9541Z",
    fill: "#CF2115"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.105 87.9541C159.383 85.5035 162.689 83.9944 166.06 84.0056C168.722 83.9657 171.39 84.7854 173.567 86.3072C174.906 87.2248 176.025 88.4203 176.994 89.7103C177.193 89.5325 177.35 89.317 177.514 89.1084C179.236 86.9651 181.591 85.288 184.261 84.5383C186.422 83.8797 188.765 83.8265 190.957 84.3731C194.453 85.2432 197.529 87.7322 198.992 91.0164C199.576 92.3723 199.951 93.8289 199.992 95.3073C200.093 98.0301 199.255 100.742 197.829 103.053C196.739 104.771 195.411 106.326 194.018 107.807C188.902 113.253 183.126 118.027 177.352 122.76C177.245 122.853 177.127 122.931 177.003 123C171.111 118.204 165.262 113.317 160.033 107.8C158.777 106.444 157.556 105.049 156.51 103.525C154.823 101.068 153.845 98.0784 154.02 95.0903C154.182 92.4542 155.286 89.8825 157.105 87.9541Z",
    fill: "#CF2115"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 55.0292,
    y1: 62.4347,
    x2: 106.331,
    y2: 74.6107,
    stroke: "#030303",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 192.614,
    y1: 57.7733,
    x2: 143.773,
    y2: 77.6414,
    stroke: "#030303",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63 170C87.1319 181.319 145.917 197.166 188 170",
    stroke: "#DE6D6D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 92.3546,
    y1: 157.632,
    x2: 88.6325,
    y2: 197.645,
    stroke: "#DE6D6D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 118.432,
    y1: 163.565,
    x2: 116.565,
    y2: 205.568,
    stroke: "#DE6D6D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 141.66,
    y1: 163.321,
    x2: 146.321,
    y2: 204.34,
    stroke: "#DE6D6D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 165.711,
    y1: 156.254,
    x2: 171.254,
    y2: 192.289,
    stroke: "#DE6D6D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinesefood);
export default __webpack_public_path__ + "static/media/Chinesefood.44f7725bf519bf2b159b6e1657e7819b.svg";
export { ForwardRef as ReactComponent };